import React from 'react';
import { array } from 'prop-types';

import { bem } from './index';

export const Rail = ({ rangeAsPercent }) => {
    const [min, max] = rangeAsPercent;
    const width = max - min;
    const railStyle = {
        left: `${min}%`,
        width: `${width}%`,
    };

    return <div draggable="false" className={bem('rail')} aria-disabled style={railStyle} />;
};

Rail.propTypes = {
    rangeAsPercent: array.isRequired,
};
